import { render, staticRenderFns } from "./PointsExclusionSettings.vue?vue&type=template&id=051eee88"
import script from "./PointsExclusionSettings.vue?vue&type=script&lang=js"
export * from "./PointsExclusionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports